<template>
    <div>
        <div></div>
        <v-card flat>
            <v-card-text>
                Here are a couple examples of emails being sent out from the system.
                Please consult the markdown document at <code>Documentation/Notifications.md</code> for further info.
            </v-card-text>
            <v-card-actions>
                <v-btn @click="sendSampleMail">
                    Send HTML Email
                </v-btn>
                <v-btn @click="sendMarkdownMail">
                    Send Markdown Email
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>

</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import SmartTable from "@/Generic/SmartTable";

export default {
    name: "ExampleEmails",
    components: {
        AppLayout,
        SmartTable
    },
    props: {
        'constants': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'valuelists': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'input': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        }
    },
    data() {
        return {
            examplefile: this.input,
        }
    },
    methods: {
        sendSampleMail() {
            axios.get(route('mail.sample').url())
                .then(response => {
                    this.$root.snackbar.success('Email Has been sent!')
                })
                .catch(function (error) {
                    this.$root.snackbar.error('Could not send email!')
                });
        },
        sendMarkdownMail() {
            axios.get(route('mail.markdown').url())
                .then(response => {
                    this.$root.snackbar.success('Email Has been sent!')
                })
                .catch(function (error) {
                    this.$root.snackbar.error('Could not send email!')
                });
        },
    },
}
</script>

<style>

</style>
